export default {
  recentlyViewed: {
    emptyTitleFiltered: '一致する項目がありません',
    emptyHintFiltered: '検索条件に一致する共有アイテムはありません。',
    tab: '共有アイテム',
    remove: '共有アイテムから削除',
    emptyTitle: 'まだ何もありません',
    emptyHint: '他のユーザーから共有された項目は、開くとここに表示されます。',
  },
  betaBadge: {
    label: 'Beta',
  },
  controls: {
    sortAriaLabel: '並べ替え',
    sortAscTooltip: '昇順 — クリックで降順',
    sortDescTooltip: '降順 — クリックで昇順',
    sortAscAriaLabel: '昇順で並べ替え中、クリックで降順に切り替え',
    sortDescAriaLabel: '降順で並べ替え中、クリックで昇順に切り替え',
    gridViewAriaLabel: 'グリッド表示',
    listViewAriaLabel: 'リスト表示',
  },
  loadMore: {
    loading: '読み込み中…',
  },
  uploadZone: {
    rejectTooLarge: 'ファイルサイズが大きすぎます。上限は {{maxGb}} GB です。',
    rejectInvalidType:
      '無効なファイル形式です。{{types}} ファイルのみ対応しています。',
    rejectGeneric: 'ファイルをアップロードできませんでした。',
    uploading: 'アップロード中…',
    repairTooltip:
      'メッシュ生成の前に CAD を診断して修復します — 隙間、非多様体エッジ、不良な面を修正します。既定の設定です。',
    wrapTooltip:
      'パーツを水密なきれいな表面で包んでからメッシュを生成します — 汚れや漏れのある CAD でもより堅牢です。パーツがメッシュ化できるかを確認するのに最適です。面ごとの境界タグはまだ引き継がれません。外部流れ・内部流れ・熱流体連成（CHT）に対応し、インポート後は固定されます — FEA が必要な場合、または個々のボディに名前を付ける必要がある場合は「修復」を選択してください。',
    repair: '修復',
    wrap: 'ラップ',
    browseFiles: 'ファイルを選択',
    fileInputLabel: 'アップロードする CAD ファイルを選択',
  },
  uploadPrep: {
    title: 'ジオメトリ前処理を選択',
    description:
      'メッシュ化の前に {{file}} をどのように準備しますか？インポート後は固定されます。',
    cancel: 'キャンセル',
    confirm: 'インポート',
  },
  aiActivity: {
    tab: 'AI の作業',
    chipNeedsYou_one: '確認が必要',
    chipNeedsYou_other: '{{count}} 件の確認が必要',
    chipNeedsYouHint_one: 'AI が修正案を用意し、承認を待っています。',
    chipNeedsYouHint_other:
      'AI が {{count}} 件の修正案を用意し、承認を待っています。',
    chipRetrying_one: 'AI が再実行中',
    chipRetrying_other: '{{count}} 件を再実行中',
    chipRetryingHint_one: '失敗したため、AI が設定を変更して再実行しています。',
    chipRetryingHint_other:
      'AI が設定を変更して {{count}} 件を再実行しています。',
    chipFixed_one: '1 件を修正',
    chipFixed_other: '{{count}} 件を修正',
    chipFixedHint_one: '失敗した後、AI が正常に動作させました。',
    chipFixedHint_other:
      '失敗した後、AI が {{count}} 件を正常に動作させました。',
    filterContext_one: '{{total}} 件中 1 件を表示 — AI が作業したもの',
    filterContext_other:
      '{{total}} 件中 {{count}} 件を表示 — AI が作業したもの',
    filterEmptyTitle: 'AI からの通知はありません',
    filterEmptyHint:
      '確認が必要なものはなく、AI は過去 {{days}} 日間に何も修正していません。',
    clearFilter: 'フィルタを解除',
    columnHeader: 'AI',
  },
} as const;
